/**
 * Centralized URL parameter names used across subscription flows
 *
 * To rename a parameter globally:
 * 1. Update the value here
 * 2. No other code changes needed - all references use these constants
 *
 * Example usage:
 * ```ts
 * const value = searchParams.get(URL_PARAMS.CANCELLED_PAYMENT);
 * ```
 */
export const URL_PARAMS = {
  /** Indicates user cancelled a payment attempt */
  CANCELLED_PAYMENT: 'cancelledPayment',
  /** Coupon/promo code ID */
  COUPON_ID: 'couponId',
  /** Whether to auto-attempt subscription on page load */
  IS_ATTEMPT_SUBSCRIBE: 'isAttemptSubscribe',
  /** Whether this is an upgrade flow */
  IS_UPGRADE: 'isUpgrade',
  /** Whether this subscription includes a trial period */
  IS_TRIAL: 'isTrial',
  /** Product price */
  PRICE: 'price',
  /** Product ID (Stripe product ID) */
  PRODUCT_ID: 'productId',
  /** Product price (alternative param name) */
  PRODUCT_PRICE: 'productPrice',
  /** Product subscription term (alternative param name) */
  PRODUCT_TERM: 'productTerm',
  /** Path to redirect to after completion */
  REDIRECT_TO: 'redirectTo',
  /** Subscription term (monthly/annually) */
  TERM: 'term',
  /** Payment verification flag */
  VERIFY_PAYMENT: 'verifyPayment',
} as const;

/**
 * URL parameters that should be ignored/filtered from search results
 */
export const IGNORED_URL_PARAMS = [
  URL_PARAMS.CANCELLED_PAYMENT,
  URL_PARAMS.IS_TRIAL,
  URL_PARAMS.PRICE,
  URL_PARAMS.REDIRECT_TO,
  URL_PARAMS.TERM,
  URL_PARAMS.VERIFY_PAYMENT,
] as const;
